
const parentMenuItem = document.querySelectorAll('.pc-header-primry__list-item');



for (let i = 0; i < parentMenuItem.length; i++) {
  parentMenuItem[i].addEventListener('mouseover', dropDownMenuOpen);
  parentMenuItem[i].addEventListener('mouseleave', dropDownMenuClose);
}

function dropDownMenuOpen(e) {
  const childMenuLink = e.currentTarget.querySelectorAll('.pc-header-primry__mega');
  console.log(childMenuLink);

  for (let i = 0; i < childMenuLink.length; i++) {
    childMenuLink[i].classList.add('is-active');
  }

}

function dropDownMenuClose(e) {
  const childMenuLink = e.currentTarget.querySelectorAll('.pc-header-primry__mega');
  console.log(childMenuLink);

  for (let i = 0; i < childMenuLink.length; i++) {
    childMenuLink[i].classList.remove('is-active');
  }

}



// ページロード時に現在のタグを選択状態にする
document.addEventListener('DOMContentLoaded', function () {
  const urlParams = new URLSearchParams(window.location.search);
  const currentTags = window.location.href.split('/tagged/')[1];

  if (currentTags) {
    const tagsArray = currentTags.split('+');
    const selectElement = document.getElementById('tag-select');

    tagsArray.forEach((tag) => {
      const option = selectElement.querySelector(`option[value="${tag}"]`);
      if (option) {
        option.selected = true;
      }
    });
  }
});
const tagSelect = document.getElementById('tag-select');

if (tagSelect) {
  tagSelect.addEventListener('change', function (event) {
    const selectedTag = event.target.value;

    if (selectedTag) {
      let currentUrl = window.location.href.split('?')[0];

      if (!currentUrl.includes('/tagged/')) {
        currentUrl += '/tagged/';
      } else {
        currentUrl = currentUrl.split('+')[0];
      }

      const newUrl = `${currentUrl}+${selectedTag}`;
      window.location.href = newUrl;
    }
  });
}